<template>
    <button type="button" class="io-toggle-field" :class="{ 'empty': typeof $slots.default === 'undefined' }" @click="type === 'add' ? addNewField() : removeField()">
        <span>
            <i class="fal fa-plus" v-if="type === 'add'"></i>
            <i class="fal fa-minus" v-else></i>
        </span>

        <slot></slot>
    </button>
</template>

<script>
export default {
  name: 'IoToggleField',

  model: {
    prop: 'currentFields',
    event: 'input',
  },

  components: {},

  props: {
    currentFields: {
      required: true,
    },
    field: {
      required: true,
    },
    type: {
      default: 'add',
    },
  },

  data() {
    return {
      displayedFields: this.currentFields,
    };
  },

  mounted() {
  },

  methods: {
    addNewField() {
      this.displayedFields = this.currentFields;
      this.displayedFields.push(this.field);
      this.$emit('input', this.displayedFields);
    },
    removeField() {
      const newFields = [];
      this.displayedFields = this.currentFields;

      for (const inx in { ...this.displayedFields }) {
        if (inx != this.field) {
          newFields.push(this.displayedFields[inx]);
        }
      }

      this.displayedFields = newFields;
      this.$emit('input', this.displayedFields);
    },
  },
};
</script>
